async function bootstrapLazy(lazyPromise, root, config) {
  return (await lazyPromise).default(root, config)
}

window.nn.registerModule('appToWeb', function (root, config) {
  return bootstrapLazy(import(/* webpackChunkName: "customer" */ './app-to-web-form'), root, config);
});